import * as i0 from '@angular/core';
import { Input, Component, NgModule } from '@angular/core';

/**
 * Loader Line Component
 */
class E11LoaderLineComponent {
    constructor() {
        /**
         * Color of the loader line
         * @type {string}
         * @default primary
         */
        this.color = 'primary';
        /**
         * Width of the loader line
         * string allows override for px or rem
         * @type {string}
         * @default ''
         */
        this.width = '';
        /**
         * Font size of the loader line
         * string allows override for px or rem
         * @type {string}
         * @default 1rem
         */
        this.fontSize = '1rem';
        /**
         * Label of the loader line
         * @type {string}
         * @default ''
         */
        this.label = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderLineComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11LoaderLineComponent, isStandalone: true, selector: "e11-loader-line", inputs: { color: "color", width: "width", fontSize: "fontSize", label: "label" }, ngImport: i0, template: `
    <div class="e11-loader-line e11-mx-auto {{ color }}" style="width: {{ width }}">
      <div class="e11-loader-line-line {{ color }}"></div>
      <span class="e11-loader-line-title e11-w-full e11-text-center e11-truncate" style="font-size: {{ fontSize }};">{{ label }}</span>
    </div>
  `, isInline: true, styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderLineComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-loader-line', standalone: true, template: `
    <div class="e11-loader-line e11-mx-auto {{ color }}" style="width: {{ width }}">
      <div class="e11-loader-line-line {{ color }}"></div>
      <span class="e11-loader-line-title e11-w-full e11-text-center e11-truncate" style="font-size: {{ fontSize }};">{{ label }}</span>
    </div>
  ` }]
        }], ctorParameters: () => [], propDecorators: { color: [{
                type: Input
            }], width: [{
                type: Input
            }], fontSize: [{
                type: Input
            }], label: [{
                type: Input
            }] } });

class E11LoaderLineModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderLineModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderLineModule, imports: [E11LoaderLineComponent], exports: [E11LoaderLineComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderLineModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderLineModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [E11LoaderLineComponent],
                    exports: [E11LoaderLineComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11LoaderLineComponent, E11LoaderLineModule };
